import { InjectionToken } from "@angular/core";

export const TINYMCE_API_KEY = new InjectionToken<string>("TINYMCE_API_KEY");

export const TINYMCE_DEFAULT_CONFIG = new InjectionToken<string>("TINYMCE_DEFAULT_CONFIG");
